<template>
  <div class="file-manager" id="file_manager_dialog" style="display: none">
    <div class="file-manager-close" onclick="_fmCloseClicked()">
      <i icon="close circle"></i>
    </div>
    <div class="file-content">
      <div class="loading" style="display: none">
        <span class="loader2"></span>
      </div>
      <ul class="bread-crumb">
        <li class="is-hover-dim-color"><i icon="home 2"></i></li>
        <li class="">/</li>
        <li class="is-hover-dim-color">images</li>
        <li class="">/</li>
        <li class="is-hover-dim-color">current</li>
      </ul>
      <ul class="action">
        <li class="is-hover-dim-color" title="Go to parent folder"
          onclick="FileManager.getCurrentFileManager().goToParentFolder(); FileManager.getCurrentFileManager().update(true);">
          <i icon="corner left up"></i>
        </li>
        <li class="is-hover-dim-color" title="Add new folder" onclick="_fmCreateFolder()">
          <i icon="folder add"></i>
        </li>
        <li class="is-hover-dim-color" title="Upload file" onclick="_openFileUploadFM()">
          <i icon="document upload"></i>
        </li>
        <li class="is-hover-dim-color" title="Delete" onclick="_deleteFMNode()">
          <i icon="trash"></i>
        </li>
        <li class="is-hover-dim-color" title="Rename" onclick="_fmRename()">
          <i icon="check 1"></i>
        </li>
        <li class="is-hover-dim-color" title="Select/Unselect all" onclick="_fmSelectAll()">
          <i icon="tick square"></i>
        </li>
        <li class="search">
          <input type="text" placeholder="search" oninput="_searchText(event)" />
        </li>
      </ul>
      <div class="file-list">
        <div class="file-upload" style="display: none" id="filemanager_dropzone">
          <span class="close-uploader-icon" title="Close" onclick="_openFileUploadFM()">
            <i icon="close 2"></i>
          </span>
          <div class="drop-zone" onclick="_fileUploadFM()">
            <i icon="document upload"></i>
            <span class="drop-zone-prompt">Drop files here or <span>click to upload</span></span>
            <input type="file" id="fileFMUploader" multiple onchange="_fileUploadFMChanged(event)" style="display: none" />
          </div>
          <div class="uploadingList"></div>
        </div>
        <ul emptyMessage="Nothing is here."></ul>
      </div>
      <ul class="bottom-action">
        <li class="is-hover-dim-color">
          <button class="btn btn-primary insert-button" disabled onclick="_fmInsertClicked()">Insert</button>
        </li>
      </ul>
    </div>
  </div>
</template>
